<template>
  <svg
    width="514"
    height="1116"
    viewBox="0 0 514 1116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M98.2577 10.5711C-120.632 184.115 -334.284 719.023 -112.747 526.29C77.4483 360.824 165.495 374.621 29.0456 713.798C-107.403 1052.97 -176.295 1129.85 205.848 912.956C587.991 696.058 463.476 933.891 500.698 1161.1"
      stroke="#B1A8D3"
      stroke-width="25"
    />
  </svg>
</template>
